import AuthForm from "./Forms/AuthForm"

const Auth = () => {
  return (
    <div className="w-full flex items-center justify-center px-6">
      <div className="w-full max-w-[400px] bg-white rounded-3xl p-10 shadow-sm border border-slate-100">
        {/* Form Header */}
        <div className="space-y-3 text-center mb-8">
          <h2 className="text-[28px] font-bold text-slate-900 tracking-tight">Welcome Back</h2>
          <p className="text-slate-500 text-[15px]">Sign in to your admin dashboard</p>
        </div>

        {/* Form Component */}
        <div className="mb-6">
          <AuthForm />
        </div>

        {/* Footer Links / Support */}
        <div className="pt-6 border-t border-slate-100 space-y-4">
          <p className="text-center text-sm text-slate-500">
            Forgot your password?
          </p>
          <button className="w-full py-3 px-4 rounded-xl border border-slate-200 text-primary font-medium hover:bg-slate-50 transition-colors text-sm">
            Contact Support
          </button>
        </div>
      </div>
    </div>
  )
}

export default Auth
